import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const eventName  = this.element.dataset.eventName;

    this.element.addEventListener('click', () =>
      this.sendGAEvent(eventName)
    );
  }

  sendGAEvent(name) {

    if (typeof gtag !== 'undefined') {
      gtag('event', name);
      console.log('GA event sent!', name);
    } else {
      console.log('GA event skipped gtag missing!', name);
    }
  }
}


